import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { AvatarsService } from './avatars.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'rl-avatar',
  template: `
    <img class="avatar" [src]="src" [srcset]="srcset" alt="" />
  `,
})
export class AvatarComponent implements OnInit {
  src: string;
  srcset: string;
  @Input() user: string;
  @Input() size?: number;
  @Input() colour?: string;

  constructor(private avatarService: AvatarsService) {}

  /**
   * Makes call to AvatarService in order to populate src and srcset attributes
   */
  ngOnInit(): void {
    this.src = this.avatarService.getImageURL(
      this.user,
      this.size,
      this.colour,
    );
    this.srcset = this.avatarService.getSrcSetValue(
      this.user,
      this.size,
      this.colour,
    );
  }
}
